import { useAuthStore } from '@/core/store/auth.store';

/**
 * Platform staff role (`RoleEnum.admin` = `"1"`), not workspace Administrator.
 * Workspace members — including customer workspace admins — use `"2"`.
 */
export const PLATFORM_ADMIN_ROLE_ID = '1' as const;

export function isPlatformAdminUser(
  user:
    | {
        role?: { id?: string | number } | null;
        impersonation?: unknown;
      }
    | null
    | undefined,
): boolean {
  if (!user || user.impersonation) {
    return false;
  }
  return String(user.role?.id ?? '') === PLATFORM_ADMIN_ROLE_ID;
}

export function useIsPlatformAdmin(): boolean {
  const user = useAuthStore((state) => state.user);
  return isPlatformAdminUser(user);
}
